import type { CSSProperties } from "react";

import EliminationBracket from "./EliminationBracket";
import type { TournamentMatch } from "../lib/api";
import { buildConsolationBracket } from "../lib/bracketFromMatches";

/** Cuadro de consolación en el Draw admin (rondas «C · …»). Sin partidos de
 * consolación no pinta nada. */
export default function ConsolationBracketCard({
  matches,
  zoom,
  onMatchClick,
}: {
  matches: TournamentMatch[];
  zoom?: number;
  onMatchClick?: (matchId: number) => void;
}) {
  const bracket = buildConsolationBracket(matches);
  if (bracket.rounds.length === 0) return null;
  const consolationMatches = matches.filter(
    (match) => (match.round_label ?? "").startsWith("C · ") && String(match.status) !== "cancelled",
  );
  const pending = consolationMatches.filter((match) => match.winner_participant_id == null).length;
  return (
    <section className="elimination-visual drw-consolation" aria-label="Cuadro de consolación">
      <div className="elimination-visual__header">
        <div>
          <h3>Cuadro de consolación</h3>
          <p className="muted">
            {consolationMatches.length} partido{consolationMatches.length === 1 ? "" : "s"} · {pending} pendiente
            {pending === 1 ? "" : "s"}. Se programan y capturan como cualquier otro (C · 1ª ronda, C · Semis…).
          </p>
        </div>
      </div>
      <div className="elimination-visual__viewport">
        <div
          className="elimination-visual__bracket"
          style={zoom ? ({ "--elimination-bracket-zoom": zoom } as CSSProperties) : undefined}
        >
          <EliminationBracket rounds={bracket.rounds} thirdPlace={bracket.thirdPlace} onMatchClick={onMatchClick} />
        </div>
      </div>
    </section>
  );
}
